<div class="row">
  <div class="col-12">
    <div class="card-body">
      <div class="pagination-entries align-items-end justify-content-between">
        <form [formGroup]="form">
          <app-searchbox
            [label]="'search_by_tenant_name_url' | translate"
            [placeholder]="'form_search' | translate"
            [formControlName]="FormField.SEARCH"
          ></app-searchbox>
        </form>
        @if (canCreateTenant) {
          <div class="mb-1">
            <a
              ds-button
              id="createTenantButton"
              [variant]="DsButtonVariants.primary"
              [routerLink]="[Api.create]"
              [relativeTo]="activatedRoute"
              >{{ 'create_tenant' | translate }}</a
            >
          </div>
        }
      </div>

      <div class="mb-3">
        <app-ngb-table
          [config]="tableConfig"
          [sortingOrder]="sortingOrder"
          [data]="tableRows$ | async"
          (onSort)="onSort($event)"
        ></app-ngb-table>
      </div>

      <div class="pagination-entries mb-0 justify-content-end">
        <ds-pagination
          [ariaLabel]="'organizations_table_pagination' | translate"
          [page]="pageNumber"
          [collectionSize]="totalRows$"
          (pageChange)="onPageNumberChanges($event)"
        ></ds-pagination>
      </div>
    </div>
  </div>
</div>
